import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { controlStaffService } from '@/services/control/staff-service';
import type { StaffMember } from '@/types/control/staff';

import { adminMutationKeys, adminQueryKeys } from '@/hooks/admin/query-keys';

/**
 * Grant tenant_creator to one email.
 *
 * Membership is read back from the same KV store the write goes to, so like
 * field mappings this is read-after-write consistent and needs no polling
 * (`docs/eventual-consistency.md` covers mesh's own read models, which do).
 * Invalidating the one staff key is enough.
 */
export function useGrantTenantCreator(): UseMutationResult<
  StaffMember,
  Error,
  string
> {
  const queryClient = useQueryClient();

  return useMutation<StaffMember, Error, string>({
    mutationKey: adminMutationKeys.grantTenantCreator(),
    mutationFn: (email) => controlStaffService.grantTenantCreator(email),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: adminQueryKeys.staffMembers(),
      }),
  });
}
